import script from "./TextElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextElement.vue?vue&type=script&lang=ts&setup=true"

import "./TextElement.vue?vue&type=style&index=0&id=2985143e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2985143e"]])

export default __exports__